var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brokerFieldData)?_c('div',{staticClass:"text-gray-500 text-sm"},[(_vm.brokerFieldData.comment)?[_vm._v(" "+_vm._s(_vm.brokerFieldData.comment)+" ")]:[_c('span',{staticClass:"text-gray-300"},[_vm._v("-")])]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }